// extracted by mini-css-extract-plugin
export default {"p":"profile_p__tv50B"};